<template>
  <div class="life-form" :style="{ padding }">
    <div class="life-form-item" v-for="(item, index) in list" :key="item.id">
      <!-- 标题 -->
      <div class="form-item-title">{{item.title}}</div>
      <div class="form-item-value">
        <!-- text -->
        <span v-if="item.type === 'text'" class="text-red">{{item.name}}</span>
        <!-- input -->
        <input v-if="item.type === 'input'" :value="item.value" :placeholder="item.tips"
        :disabled="item.disabled ? true: false" :type="item.isNumber ? 'number': 'text'"
        @input="handleInput($event, list[index], index, item.isNumber)" />
        <span v-if="item.type === 'select'" class="select-text"
        :class="{ 'select-text-act': item.name }">
        	{{item.name ? item.name: item.tips}}
        </span>
      </div>
      <!-- select -->
      <div class="form-item-select">
        <el-select v-if="item.type === 'select'" :value="item.value" :placeholder="item.tips"
        clearable :popper-append-to-body="false" @change="selectChange($event, item, index)">
          <el-option v-for="ite in item.list" :key="ite.id" :label="ite.name" :value="ite.id" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
      	type: Object,
      	default: () => {}
      },
      list: {
        type: Array,
        default: () => []
      },
      padding: {
        type: String,
        default: '0 16px'
      }
    },
    watch: {
      list: {
        handler(newVal) {
          this.emitFormVal(newVal)
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      emitFormVal(list) {
        const copyForm = {}
        list.forEach(item => {
        	copyForm[item.key] = item.value
        })
        this.$emit('update:value', copyForm)
        this.$emit('listChange', this.list)
      },
      handleInput(e, item, index, isNumber) {
        let str = e.target.value
        //限制只能输入一个小数点
        if (isNumber) {
          if (str.indexOf(".") != -1) {
            const str_ = str.substr(str.indexOf(".") + 1);
            if (str_.indexOf(".") != -1) {
              str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
            }
          }
          str = str.replace(/[^\d^\.]+/g, '');
        }
        // this.$set(this.list[i], 'value', str)
        this.setFormItemValue(item, index, str)
      },
      selectChange(id, item, index) {
      	this.setFormItemValue(item, index, id)
      },
      // 更改某一项值
      setFormItemValue(item, index, val) {
      	const newItem = JSON.parse(JSON.stringify(item))
      	newItem.value = val
        if (item.type === 'select') {
        	const { name } = item.list.find(ite => ite.id === val)
        	newItem.name = name
        }
      	const newList = JSON.parse(JSON.stringify(this.list))
      	newList[index] = newItem
      	this.$emit('update:list', newList)
      }
    }
  }
</script>

<style lang="less" scoped>

  /deep/ .el-select-dropdown {
    position: absolute !important;
    z-index: 15 !important;
  }

  .life-form {
    width: 100%;

    /deep/ .el-input__inner {
      background-color: transparent;
      text-align: right;
      padding-right: 0;
      font-size: 16px;
    }
    /deep/ .el-input__suffix {
      display: none;
    }

    .life-form-item {
      height: 56px;
      background: #F8F8FA;
      border: 0.5px solid #E2E3E4;
      border-radius: 16px;
      padding: 0 18px 0 6px;
      margin-bottom: 15px;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;

      .select-text {
        width: 100%;
      	overflow: hidden;
      	white-space: nowrap;
      	text-overflow: ellipsis;
      	color: #c8c7ce;
        text-align: right;
      	&-act {
      		color: #686777;
      	}
      }

      .form-item-select {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        /deep/ .el-select {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 12;
          .el-input {
            width: 100%;
            height: 100%;
            .el-input__inner {
              width: 100%;
              height: 100%;
              opacity: 0;
            }
          }
        }
      }

      .form-item-title {
        font-family: Poppins;
        font-size: 16px;
        color: #686777;
        font-weight: 500;
        line-height: 24px;
      }

      .form-item-value {
        justify-content: flex-end;
        position: relative;
        z-index: 9;
        display: flex;
        flex: 1;
        width: 0;
        padding-left: 12px;

        input {
          width: 100%;
          font-size: 16px;
          color: #686777;
          height: 24px;
          font-weight: 500;
          text-align: right;
          padding-left: 5px;
        }

        // span {
        //   font-size: 16px;
        //   color: #ED3A42;
        // }

        .text-red {
        	font-size: 32rpx;
        	color: #ED3A42 !important;
        	display: block;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  input {
    background: none;
    outline: none;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/life-form.vue